export default __webpack_public_path__ + "static/media/Picture1.42399400.png";